function Service() {
    return (
        <div>
            <p>Ini Service</p>
        </div>
    )
}

export default Service;